import { Box, Flex, PrimaryButton } from "flicket-ui";
import { ReactNode } from "react";

interface FooterActionBarProps {
  priceInfo: ReactNode;
  buttonText: string;
  onAction: () => void;
  isLoading: boolean;
  isDisabled: boolean;
}

export const FooterActionBar = ({
  priceInfo,
  buttonText,
  onAction,
  isLoading,
  isDisabled,
}: FooterActionBarProps) => {
  return (
    <Flex width="100%" alignItems="center" justifyContent="space-between">
      <Box>{priceInfo}</Box>

      <PrimaryButton
        minW={{ sm: 330 }}
        width={{ _: "50%", sm: "auto" }}
        onClick={() => void onAction()}
        isLoading={isLoading}
        disabled={isDisabled}
      >
        {buttonText}
      </PrimaryButton>
    </Flex>
  );
};
